import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "919edSF2N1E5JD0+OkkTYDm", "Ad4399", undefined);

//@ts-nocheck
import { _decorator, log } from "cc";
import { E_ADEventType } from "../../EnumBase";
import { App } from "../../manager/App";
import AdEvent from "../AdEvent";
var ccclass = _decorator.ccclass;

var Ad4399 = ccclass(_class = (_temp = /*#__PURE__*/function () {
  function Ad4399() {
    _defineProperty(this, "_gameId", 660730283);

    _defineProperty(this, "_bannerId", "503498176");

    _defineProperty(this, "_interstitialId", "194723805");

    _defineProperty(this, "_videoId", "327981064");

    _defineProperty(this, "_banner", {});

    _defineProperty(this, "_interstitialAd", {});

    _defineProperty(this, "_videoAd", {});

    _defineProperty(this, "_bannerLoadTimes", 0);

    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "_interstitialLoadTimes", 0);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "_videoLoadTimes", 0);

    _defineProperty(this, "videoAdLoaded", false);

    _defineProperty(this, "_isVideoPlayed", false);

    _defineProperty(this, "_isADStart", false);

    _defineProperty(this, "_isPlayAd", false);

    _defineProperty(this, "_isCallPlay", false);

    _defineProperty(this, "_isCanPlay", false);

    _defineProperty(this, "isBannering", false);

    _defineProperty(this, "_adLeftNums", 0);
  }

  var _proto = Ad4399.prototype;

  _proto.init = function init() {
    // this.addStatistics();
    log("begin init 4399");
    var that = this; // let body = document.getElementsByTagName('body')[0];
    // let sc_body = document.createElement('script');
    // sc_body.type = 'text/javascript';
    // sc_body.async = true;
    // sc_body.src = 'http://h.api.4399.com/h5mini-2.0/h5api-interface.php';
    // sc_body.onload = () => {
    //     log("............4399Api.onLoad......");
    //     that.checkCanPlay();
    // }
    // sc_body.onerror = () => {
    //     log("............4399Api.onerror......");
    // }
    // body.appendChild(sc_body);

    that.checkCanPlay();
  };

  _proto.checkCanPlay = function checkCanPlay() {
    this._adLeftNums = 0;
    var that = this;

    if (window["h5api"]) {
      window["h5api"].canPlayAd(function (data) {
        console.log("是否可播放广告", data.canPlayAd, "剩余次数", data.remain);

        if (data.canPlayAd && data.remain > 0) {
          that._isCanPlay = true;
        } else {
          that._isCanPlay = false;
        }

        that._adLeftNums = data.remain;
      });
    }
  };

  _proto.playAD = function playAD() {
    if (this._isCallPlay) return;
    this._isCallPlay = true;
    var that = this;
    console.log("...........playAD......");

    if (window["h5api"]) {
      window["h5api"].playAd(function (obj) {
        if (obj.code === 10000) {
          App.SoundMgr.adState = true;
          log("开始播放");
        } else if (obj.code === 10001) {
          that._isCallPlay = false;
          log("播放结束");
          AdEvent.I.handleEvent(E_ADEventType.video_showOver);
          App.SoundMgr.adState = false;
          that.checkCanPlay();
        } else {
          that._isCallPlay = false;
          log("广告异常");
          App.SoundMgr.adState = false;
          AdEvent.I.handleEvent(E_ADEventType.video_showFail);
          that.checkCanPlay();
        }
      });
    }
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {};

  _proto.showBannerAd = function showBannerAd() {};

  _proto.hideBannerAd = function hideBannerAd() {};

  _proto.destroyBannerAd = function destroyBannerAd() {};

  _proto.isLoad_banner = function isLoad_banner() {
    return false;
  };

  _proto.isPreLoad_banner = function isPreLoad_banner() {
    return false;
  } // 创建插屏广告 展示一次调用一次创建
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   interstitialAdId: string 插屏广告ID 需后台申请
  //   style: int 广告类型 1 全屏 2 半屏
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {};

  _proto.showInterstitialAd = function showInterstitialAd() {
    if (this.interstitialAdLoaded) {//    this.playAD();
    } else {
      console.log("this._interstitialAd 广告未加载成功");
    }
  };

  _proto.hideInterstitialAd = function hideInterstitialAd() {
    console.log("this._interstitialAd 游戏隐藏插屏广告");
  };

  _proto.destroyInterstitialAd = function destroyInterstitialAd() {
    console.log("this._interstitialAd 游戏销毁插屏广告");
  };

  _proto.isLoad_interstitial = function isLoad_interstitial() {
    return this.interstitialAdLoaded;
  };

  _proto.isPreLoad_interstitial = function isPreLoad_interstitial() {
    return true;
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {};

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    if (this._isCanPlay) {
      this.playAD();
      console.log("rewardedvideoAd 视频广展示");
    } else {
      console.log("rewardedvideoAd 视频广告未加载成功");
    }
  };

  _proto.destroyRewardedVideoAd = function destroyRewardedVideoAd() {};

  _proto.isLoad_rewarded = function isLoad_rewarded() {
    /**
    * 获得是否可以播放广告及剩余次数
    * @param {func} callback 回调函数
    * @return boolean 是否可播放
    */
    return this._isCanPlay;
  };

  _proto.isPreLoad_rewarded = function isPreLoad_rewarded() {
    return true;
  };

  _proto.isEnable = function isEnable() {
    // this._adLeftNums > 0;
    return true;
  }
  /**
  * 加入统计 dob5等平台使用
  */
  // addStatistics () {
  //     let head = document.getElementsByTagName('body')[0];
  //     let script = document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.async = true;
  //     script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-155756551-1';
  //     script.onload = () => {
  //         log("............statistics.onLoad......");
  //     }
  //     head.appendChild(script);
  //     if (!window["dataLayer"]) {
  //         window["dataLayer"] = [];
  //     }
  //     window["gtag"] = (...args) => {
  //         window["dataLayer"].push(args);
  //     }
  //     window['gtag']("js", new Date());
  //     window['gtag']("config", "UA-155756551-1");
  //     // let sCb: HTMLScriptElement = document.createElement('script');
  //     // sCb.type = 'text/javascript';
  //     // sCb.text = 'window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag("js", new Date());gtag("config", "UA-170611817-1");'
  //     // head.appendChild(sCb); 
  // }
  ;

  return Ad4399;
}(), _temp)) || _class;

export { Ad4399 as default };

_cclegacy._RF.pop();